/**
 * The command sequence runs the monitoring page has heard of, for the Command
 * Sequences drawer. Mounted beside `BankMessagesProvider` on `MonitoringPage`,
 * so it listens for exactly as long as the page holds its WebSocket.
 */
import React, { createContext, useContext, useEffect, useReducer } from "react";

import { subscribeSequenceProgress } from "../socketMessageState/sequenceProgressBus";
import { EMPTY_SEQUENCE_RUNS, reduceSequenceRuns, type SequenceRunsState } from "./sequenceRuns";

const SequenceRunsContext = createContext<SequenceRunsState>(EMPTY_SEQUENCE_RUNS);

export function SequenceRunsProvider({ children }: { children: React.ReactNode }) {
  const [runs, record] = useReducer(reduceSequenceRuns, EMPTY_SEQUENCE_RUNS);
  useEffect(() => subscribeSequenceProgress(record), []);
  return <SequenceRunsContext.Provider value={runs}>{children}</SequenceRunsContext.Provider>;
}

/** The active and recent runs; empty outside a `SequenceRunsProvider`. */
export function useSequenceRuns(): SequenceRunsState {
  return useContext(SequenceRunsContext);
}
